// 公用js

class Common {
    goPage(url,context,query){
        context.$router.push(url,query)
    };

    handleTimeOne(times) {
        var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
        var timestr = ""+timearr[0]+"-" + timearr[1] + "-" + timearr[2]
        //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
        return timestr
      }
      
     handleTimeTwo(times) {
        var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
        var timestr = ""+timearr[0]+"." + timearr[1]
        //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
        return timestr
      }

      handleTimeThree(times) {
        var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
        var timestr = ""+timearr[1]
        // console.log(timestr);
        //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
        return timestr
      }

      handleTimeFour(times) {
        var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
        var timestr = ""+timearr[2]
        //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
        return timestr
      }

      handleTimeFive(times) {
        var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
        var timestr = ""+timearr[1]+"." + timearr[2]
        //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
        return timestr
      }

      transformEnglish(month) {
        var data = month.split("")[1];
        var enArr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var _month = enArr[data-1]
        return _month
      }

      groupBy( array , id ) {
        let groups = {};
        array.forEach( function( o ) {
            let group = JSON.stringify( o[id] );
            groups[group] = groups[group] || [];
            groups[group].push( o );
        });
        return Object.values(groups);
    }
}

export default new Common()